import * as React from "react";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import {none, Option} from "ts-option";
import {connect, Dispatch} from "react-redux";
import {RootState} from "../../store/reducer/root/RootState";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import DataGrid from "../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import Routes from "../../navigation/route/Route";
import {PartnerBrandSearch} from "../../model/partnerBrand/PartnerBrand";
import DateUtils from "../../utils/DateUtils";
import CurrencyHelper from "../../helper/CurrencyHelper";
import {CommonDetailsStatusRow} from "./common/CommonDetailsStatusRow";
import {BillsMap} from "../../store/reducer/bill/BillState";
import {objectIterator} from "../../utils/DictionaryUtils";
import {fetchBills} from "../../store/action/bill/bill";
import PartnerBrandSelectionComponent from "../partnerBrand/search/PartnerBrandSelectionComponent";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";
import Bill from "../../model/bill/Bill";

const arrow = require('../../../resources/hiber/img/guide-arrow.png');

interface ReduxProps {
	/**
	 * Bills map.
	 */
	billsById: BillsMap;
}

interface DispatchProps {
	/**
	 * Fetch bills action.
	 */
	fetchBills: (partnerBrandId: string) => void;
}

interface State {
	/**
	 * Selected partner brand.
	 */
	selectedPartnerBrand: Option<PartnerBrandSearch>;
}

type Props = ReduxProps & DispatchProps & RouteComponentProps<{}>;

/**
 * All bills view. This will probably be deleted after bills workspace is done.
 */
class BillsView extends React.PureComponent <Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {selectedPartnerBrand: none}
	}

	fetchData = (): void => {
		this.state.selectedPartnerBrand.map(pb => this.props.fetchBills(pb.id));
	};

	render() {
		return (
			<div className={"l-page"}>
				<CommonDetailsStatusRow
					icon={Icon.Quote}
					title={"Bills"}
					onBackClick={this.props.history.goBack}
					refNumPath={["Accounting", "Bills"]}
					additionalComponent={this.renderPartnerBrandSelector()}/>
				{this.renderTable()}
			</div>
		);
	}

	renderTable = () => {
		return this.state.selectedPartnerBrand.map(pb => {
			const bills = objectIterator(this.props.billsById).filter(bill => bill.partnerBrandId === pb.id);
			if (!bills.length) {
				return this.renderNoDataContent();
			}
			const sortedBills = bills.sort(Bill.compare);
			return (
				<DataGrid>
					<thead>
					<tr className="c-common-details_table-header-row">
						<th className="c-common-details_table-desc-cell">REFERENCE NUMBER</th>
						<th>STATUS</th>
						<th>CREATION DATE</th>
						<th>TOTAL</th>
					</tr>
					</thead>
					<tbody>
					{sortedBills.map((item) =>
						<tr key={item.id} className="c-common-details_table-row" style={{cursor: "pointer"}}
							onClick={() => this.onRowClick(item.id)}>
							<td className="c-common-details_table-desc-cell">{item.referenceNumber}</td>
							<td>{item.status}</td>
							<td>{item.creationDateTime.format(DateUtils.DATE_TIME_FORMAT)}</td>
							<td>{CurrencyHelper.toCurrency(item.total)}</td>
						</tr>)}
					</tbody>
				</DataGrid>);
		}).getOrElse(this.renderNoPbSelectedContent)
	};

	renderPartnerBrandSelector = () => {
		return (
			<div className="c-common-details_partner-brand-selector">
				<PartnerBrandSelectionComponent selectedValue={this.state.selectedPartnerBrand}
												onSelect={this.onPartnerBrandChange}
												placeholder="Choose a partner brand..."/>
			</div>
		);
	};

	renderNoPbSelectedContent = () => {
		return (
			<div>
				<img src={arrow} className="c-common-details_no-pb-selected-warning_partner-brand-guide-arrow"/>
				<div className="c-common-details_no-pb-selected-warning_text">
					Please choose a partner brand to continue.
				</div>
			</div>
		);
	};

	renderNoDataContent = () => {
		return (
			<div className="c-common-details_no-pb-selected-warning_text">
				No data for selected partner brand.
			</div>
		);
	};

	onPartnerBrandChange = (selectedPartnerBrand: Option<PartnerBrandSearch>) => this.setState({selectedPartnerBrand},
		this.fetchData);

	onRowClick = (invoiceId: string) => this.props.history.push(Routes.BillDetailsView(invoiceId));

}

function mapStateToProps(state: RootState) {
	const billsById = state.bill.billsMap;
	return {billsById};
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchBills: (partnerBrandId: string) => dispatch(
			fetchBills(partnerBrandId, () => {}, (error) => notifyBugsnagAndShowToast(error, "Fetch bills")))
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BillsView))
